import React from 'react';
import { AiOutlineQuestionCircle } from "react-icons/ai";
import './HelpSection.scss';

const HelpSection = () => {
  return (
    <div className="help-section">
      <div className="help-content">
        <div className="help-heading">
          <span>Issues with immediate payment?</span>
          <a href="/help">Contact Customer Service</a>
        </div>
        <p>Please select according to your<span className="highlight">Payment currency is different</span>，The payment method for this payment is determined based on the actual exchange rate of the transaction:</p>
        <ul className="help-instructions">
          <li>The exchange rate is better than that of banks in real time</li>
          <li>The exchange rate is better than the above major banks or payments, so be cautious</li>
        </ul>
      </div>
      <AiOutlineQuestionCircle className="help-icon" />
    </div>
  );
};

export default HelpSection;
